import { useEffect, useMemo } from "react";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import Bowser from "bowser";

import { ERROR } from "types/snackBar.constant";

export const useBrowserSupported = () => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const isBrowserSupported = useMemo(() => {
        const userAgent = window.navigator.userAgent;
        const browser = Bowser.getParser(userAgent);
        return userAgent
            ? browser.satisfies({
                  ios: {
                      safari: ">=6",
                  },
                  chrome: ">=16",
                  firefox: ">=11",
                  safari: ">=7",
                  edge: ">=12",
                  ie: ">=10",
                  opera: ">=12.1",
                  samsung_internet: ">=4",
              })
            : true;
    }, []);

    useEffect(() => {
        if (!isBrowserSupported) {
            enqueueSnackbar(
                <>
                    {t("outdatedBrowser1", {
                        product:
                            window.env.REACT_APP_THEME === "votebox"
                                ? "Votebox"
                                : "Quizzbox",
                    })}
                    <br />
                    {t("outdatedBrowser2")}
                    <br />
                    {t("outdatedBrowser3")}
                </>,
                {
                    variant: ERROR,
                    persist: true,
                    key: "outdatedBrowserWarning",
                    preventDuplicate: true,
                },
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBrowserSupported]);

    return isBrowserSupported;
};
